/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ExportPlansRequestDTO { 
    /**
     * Measured client identifier for the export request.
     */
    clientId: number;
    /**
     * Brand identifier for the export request.
     */
    brandId: number;
    /**
     * Conversion type used to determine which comparison data to export.
     */
    conversionType: string;
    /**
     * Start date for the export window in ISO-8601 date format.
     */
    dateStart: string;
    /**
     * End date for the export window in ISO-8601 date format.
     */
    dateStop: string;
    /**
     * Optional view type that determines whether the export is formatted for ROAS or CPO.
     */
    viewType?: ExportPlansRequestDTO.ViewTypeEnum;
    /**
     * Optional table dimension used to group the exported rows.
     */
    tableDimension?: ExportPlansRequestDTO.TableDimensionEnum;
    /**
     * Plan identifiers to export. The endpoint supports a small batch for comparison.
     */
    planIds: Array<number>;
}
export namespace ExportPlansRequestDTO {
    export type ViewTypeEnum = 'ROAS' | 'CPO';
    export const ViewTypeEnum = {
        Roas: 'ROAS' as ViewTypeEnum,
        Cpo: 'CPO' as ViewTypeEnum
    };
    export type TableDimensionEnum = 'channel' | 'segment' | 'tactic';
    export const TableDimensionEnum = {
        Channel: 'channel' as TableDimensionEnum,
        Segment: 'segment' as TableDimensionEnum,
        Tactic: 'tactic' as TableDimensionEnum
    };
}


